import React from 'react';
import { Box, Button, Divider, Heading, Modal, ModalBody, Text } from '@razorpay/blade/components';

export function ExitConfirmationModal({
  isOpen,
  onClose,
  onConfirmExit,
  isEditMode = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirmExit: () => void;
  isEditMode?: boolean;
}) {
  const flowType = isEditMode ? 'edit' : 'creation';
  const actionText = isEditMode ? 'editing' : 'creation';

  return (
    <Modal isOpen={isOpen} size="small" onDismiss={onClose}>
      <ModalBody>
        <Box padding="spacing.5" display="flex" flexDirection="column" gap="spacing.5">
          <Heading size="large" weight="semibold">
            Exit {flowType} flow ?
          </Heading>

          <Text size="medium" weight="regular" color="surface.text.gray.subtle">
            You are about to exit the {actionText} flow. All progress will be discarded.
          </Text>
        </Box>

        <Divider marginY="spacing.5" />
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" marginTop="spacing.5">
          <Button variant="secondary" onClick={onClose}>
            Back to {actionText}
          </Button>

          <Button onClick={onConfirmExit}>Exit now</Button>
        </Box>
      </ModalBody>
    </Modal>
  );
}
